import { useNavigate } from "react-router-dom";

type IPageRef = {
  pageRef?: React.MutableRefObject<HTMLDivElement | null>;
};

function AccountDeletion({ pageRef }: IPageRef) {
  const navigate = useNavigate();
  return (
    <div className="mt-[25px]" ref={pageRef} title="Account Deletion">
      <h1 className="font-[700] text-[24px] xlsm:text-[20px] leading-[33px] xlsm:leading-[30px] text-[#2a3342] tracking-normal">
        <span>16.</span> Account Deletion
      </h1>
      <div className="text-[#2a3342] text-[18px] xlsm:text-[17px] leading-[28px] font-[400] mt-[15px] tracking-normal space-y-4">
        <p>
          You may request deletion of your Shiga account and associated personal
          data by contacting us at{" "}
          <a href="mailto:help@shiga.io">
            <i className="font-[600] text-hbrand-500">admin@shiga.io</i>
          </a>
          .
        </p>
        <p>
          For step-by-step instructions on how to delete your account, please
          visit our{" "}
          <p
            onClick={() => {
              navigate("/delete-account");
            }}
            className="cursor-pointer font-[600] text-hbrand-500"
          >
            Account Deletion Guide.
          </p>
        </p>
        <p>
          Note: Some data may be retained where required by law or for
          legitimate business purposes, such as transaction records for
          financial compliance.
        </p>
      </div>
    </div>
  );
}

export default AccountDeletion;
